import axios from "axios";
import { WALLET_SETTINGS } from "../api";

export async function updateWallet(data) {
  try {
    const response = await axios.patch(WALLET_SETTINGS, data);
    if (response.status != 200) {
      throw new Error("Something went wrong.");
    }
    return true;
    // Handle successful response if needed
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getWalletDetails(data) {
  try {
    const response = await axios.post(WALLET_SETTINGS, data);
    if (response.status != 200) {
      throw new Error("Something went wrong.");
    }
    return response?.data?.networks;
    // Handle successful response if needed
  } catch (error) {
    console.error(error);
    throw error;
  }
}
